export const getTrackingUrlParam = ({ placement, query = "" }: { placement: string; query?: string }) => {
    const src = `src=search_${placement}`;
    const searchTerm = query ? `&searchTerm=${encodeURIComponent(query)}` : "";

    return `?${src}${searchTerm}`;
};
